<template>
  <div
    class="customer-service"
    id="div-customer-service"
    :class="{
      kaka: props.siteId === siteEnum.KAKA,
    }"
  >
    <div class="inner">
      <div class="title">
        {{ t('common.zhuanshukefufuwu') }}
      </div>
      <div class="subtitle">
        EXCLUSIVE CUSTOMER SERVICE
      </div>
      <div class="bar" />
      <div class="services">
        <div
          class="contact-boxes"
          :style="props.siteId === siteEnum.VNM ? 'gap: 50px;' : ''"
        >
          <div class="contact-box" v-for="(c, i) in contactlist" :key="i">
            <div class="contacticon">
              <img
                v-if="c.icon === 'czalo'"
                :src="require(`../../assets/images/${c.icon}.png`)"
              >
              <img
                v-else-if="c.icon === 'whatsapp'"
                :src="require(`../../assets/images/${c.icon}.png`)"
              >
              <img
                v-else-if="c.icon === 'sigua'"
                :src="require(`../../assets/images/${c.icon}.png`)"
              >
              <img
                v-else-if="c.icon === 'santiao'"
                :src="require(`../../assets/images/${c.icon}.png`)"
              >
              <img
                v-else
                :src="require(`../../assets/images/${c.icon}.svg`)"
              >
            </div>
            <div class="type">{{ c.type }}</div>

            <div
              class="link text-blue"
              v-if="c.icon === 'ctelegram' && props.siteId === siteEnum.LK6"
              @click="openTgLink(c.link)"
            >
              {{ c.link }}
            </div>
            <div class="link" v-else>{{ c.link }}</div>

            <div class="buttons">
              <el-button
                @click="copyMessage(i, btn.text, btnkey)"
                v-for="(btn, btnkey) in c.btns"
                :key="btnkey"
                :type="btnkey === 1 ? 'primary' : 'plain'"
              >
                {{ btn.text }}
              </el-button>
            </div>
          </div>
          <div class="girl">
            <img
              v-if="props.siteId === siteEnum.LH1"
              src="../../assets/images/login/cus-guy.png"
            >
            <img
              v-else-if="
                props.siteId === siteEnum.VNM || props.siteId === siteEnum.KAKA
              "
              src="../../assets/images/login/cus-girl-vn.png"
            >
            <img v-else src="../../assets/images/login/cus-girl.png">
            <!--          <div v-if="props.siteId === '15'" class="kaka-cs-24">-->
            <!--            <img src="../../assets/images/kaka/cs-24-kaka.svg">-->
            <!--            <p>-->
            <!--              {{ $t('common.24.line1') }}-->
            <!--              <br>-->
            <!--              <br>-->
            <!--              {{ $t('common.24.line2') }}-->
            <!--            </p>-->
            <!--          </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
/* eslint-disable */
import { onMounted, defineProps, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { siteEnum } from '@/consts/SiteEnum'

const { t } = useI18n()

const props = defineProps({
  siteId: {
    type: [String, Number], // Specify the allowed types for the prop
    required: true,
  },
})
const skypeLink = () => {
  if (props.siteId === siteEnum.DY2) {
    return 'live:.cid.1b8d9a018a52a8f5'
  } else if (props.siteId === siteEnum.XF1) {
    return 'live:.cid.178f76828f54342e'
  } else if (props.siteId === siteEnum.LH1) {
    return 'live:.cid.8099acb97a5ea41'
  } else if (props.siteId === siteEnum.LK6) {
    return null
  } else {
    return 'live:.cid.1a1ab9b6b5b0721f'
  }
}
const loofahLink = () => {
  if (props.siteId === siteEnum.LH1) {
    return 'LH1112222'
  } else if (props.siteId === siteEnum.XF1) {
    return 'LH12341234'
  } else if (props.siteId === siteEnum.DY2) {
    return 'LH1112222'
  } else if (props.siteId === siteEnum.LK6) {
    return null
  }
}
const bubbleLink = () => {
  if (props.siteId === siteEnum.DY2) {
    return 'LH1008666'
  } else if (props.siteId === siteEnum.XF1) {
    return 'xfdlkf001'
  } else if (props.siteId === siteEnum.LK6) {
    return null
  } else {
    // console.log(props.siteId , siteEnum.LK6,'dan2')
    return 'Lh16816808'
  }
}

const amicoLink = () => {
  if (props.siteId === siteEnum.DY2) {
    return 'vip777'
  } else if (props.siteId === siteEnum.XF1) {
    return 'vip444'
  } else {
    return 'vip333'
  }
}

const mailLink = () => {
  if (props.siteId === siteEnum.LH1) {
    return 'mailto:affiliate@e8007.com'
  } else if (props.siteId === siteEnum.VNM) {
    return 'vnaffiliates@tf88.com'
  } else if (props.siteId === siteEnum.XF1) {
    return ''
  } else {
    return 'mailto:affiliate@dyvip99.com'
  }
}
const qqLink = () => {
  if (props.siteId === siteEnum.LH1) {
    return '415203453'
  } else if (props.siteId === siteEnum.XF1) {
    return '415203453'
  } else if (props.siteId === siteEnum.DY2) {
    return '415203453'
  } else {
    return '100983290'
  }
}

const telegramLink = () => {
  if (props.siteId === siteEnum.LH1) {
    return '@leihuo686'
  } else if (props.siteId === siteEnum.KAKA) {
    return '@dailykakagame'
  } else if (props.siteId === siteEnum.VNM) {
    return '@dailitf88'
  } else if (props.siteId === siteEnum.XF1) {
    return '@xf100200'
  } else if (props.siteId === siteEnum.DY2) {
    return '@dyghs_01'
  } else if (props.siteId === siteEnum.LK6) {
    return 'xy66vip'
  } else {
    return '@leihuo123'
  }
}
const contactlist = ref()

const initContactList = () => {
  contactlist.value = [
    {
      icon: 'cmail',
      type: t('common.email'),
      link: mailLink(),
      btns: [
        {
          text: t('common.askus'),
          action: '',
        },
      ],
    },
    {
      icon: 'cqq',
      type: t('common.qq'),
      link: qqLink(),
      btns: [
        {
          text: t('common.copy'),
          action: '',
        },
        {
          text: t('common.download'),
          action: 'https://im.qq.com/index/',
        },
      ],
    },
    {
      icon: 'cteams',
      type: t('common.teams'),
      link: skypeLink(),
      btns: [
        {
          text: t('common.copy'),
          action: '',
        },
        {
          text: t('common.download'),
          action:
            'https://www.microsoft.com/en-sg/microsoft-teams/download-app',
        },
      ],
    },
    {
      icon: 'ctelegram',
      type: 'Telegram',
      link: telegramLink(),
      btns: [
        {
          text: t('common.copy'),
          action: '',
        },
        {
          text: t('common.download'),
          action: 'https://telegram.org/',
        },
      ],
    },
    {
      icon: 'santiao',
      type: t('common.santiao'),
      link: loofahLink(),
      btns: [
        {
          text: t('common.copy'),
          action: '',
        },
        {
          text: t('common.download'),
          action: 'https://ya.cn/index.html',
        },
      ],
    },
    // {
    //   icon: 'bubble-logo',
    //   type: t('common.paopao') + '?',
    //   link: bubbleLink(),
    //   btns: [{
    //     text: t('common.copy'),
    //     action: ''
    //   },
    //   {
    //     text: t('common.download'),
    //     action: 'https://paopaoim.com/index.html'
    //   }]
    // }
  ]
  if (props.siteId === '8') {
    contactlist.value = [
      {
        icon: 'cmail',
        type: t('common.email'),
        link: mailLink(),
        btns: [
          {
            text: t('common.askus'),
            action: '',
          },
        ],
      },
      {
        icon: 'whatsapp',
        type: t('common.whatsapp'),
        link: '+84379357818',
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://wa.me/qr/AZRPLDZZ23DWO1',
          },
        ],
      },
      {
        icon: 'cteams',
        type: t('common.teams'),
        link: 'live:.cid.f284aa8f5c120ae5',
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action:
              'https://www.microsoft.com/en-sg/microsoft-teams/download-app',
          },
        ],
      },
      {
        icon: 'ctelegram',
        type: 'Telegram',
        link: telegramLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://telegram.org/',
          },
        ],
      },
    ]
  }
  if (props.siteId === '15') {
    contactlist.value = [
      {
        icon: 'cflygram-kaka',
        type: 'Telegram',
        link: telegramLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://telegram.org/',
          },
        ],
      },
    ]
  }
  if (props.siteId === siteEnum.LH1) {
    contactlist.value = [
      {
        icon: 'cmail',
        type: t('common.email'),
        link: mailLink(),
        btns: [
          {
            text: t('common.askus'),
            action: '',
          },
        ],
      },
      {
        icon: 'cqq',
        type: t('common.qq'),
        link: qqLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://im.qq.com/index/',
          },
        ],
      },
      {
        icon: 'cteams',
        type: t('common.teams'),
        link: skypeLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action:
              'https://www.microsoft.com/en-sg/microsoft-teams/download-app',
          },
        ],
      },
      {
        icon: 'ctelegram',
        type: 'Telegram',
        link: telegramLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://telegram.org/',
          },
        ],
      },
      {
        icon: 'santiao',
        type: t('common.santiao'),
        link: loofahLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://ya.cn/index.html',
          },
        ],
      },
    ]
  }
  if (props.siteId === siteEnum.XF1) {
    contactlist.value = [
      {
        icon: 'cmail',
        type: t('common.email'),
        link: mailLink(),
        btns: [
          {
            text: t('common.askus'),
            action: '',
          },
        ],
      },
      {
        icon: 'cqq',
        type: t('common.qq'),
        link: qqLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://im.qq.com/index/',
          },
        ],
      },
      {
        icon: 'cteams',
        type: t('common.teams'),
        link: skypeLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action:
              'https://www.microsoft.com/en-sg/microsoft-teams/download-app',
          },
        ],
      },
      {
        icon: 'ctelegram',
        type: 'Telegram',
        link: telegramLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://telegram.org/',
          },
        ],
      },
      {
        icon: 'sigua',
        type: t('common.loofah'),
        link: loofahLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://ya.cn/index.html',
          },
        ],
      },
    ]
  }
  // 上面 if 各自有的客服管道
  // 下面兩個 if 是大家固定要刪除或新增的 就不動
  if (
    props.siteId === siteEnum.DY2 ||
    props.siteId === siteEnum.XF1 ||
    props.siteId === siteEnum.LH1
  ) {
    contactlist.value.shift()
  }
  if (
    props.siteId === siteEnum.DY2 ||
    props.siteId === siteEnum.XF1 ||
    props.siteId === siteEnum.LH1
  ) {
    contactlist.value.push({
      icon: 'amico-logo',
      type: 'AMICO',
      link: amicoLink(),
      btns: [
        {
          text: t('common.copy'),
          action: '',
        },
        {
          text: t('common.download'),
          action: 'https://am35.cc/',
        },
      ],
    })
  }
  if (props.siteId === siteEnum.LK6) {
    contactlist.value = [
      {
        icon: 'ctelegram',
        type: 'Telegram',
        link: telegramLink(),
        btns: [
          {
            text: t('common.copy'),
            action: '',
          },
          {
            text: t('common.download'),
            action: 'https://telegram.org/',
          },
        ],
      },
    ]
  }
}

const openTgLink = link => {
  window.open('https://t.me/' + link, '_blank')
}

const copyMessage = (position, text, btnPosition) => {
  console.log(position)
  console.log(text)
  console.log(contactlist.value)
  if (text === t('common.askus')) {
    var mailtoLink = contactlist.value[position].link
    if (props.siteId === '8') {
      mailtoLink = 'mailto:' + contactlist.value[position].link
    }
    window.open(mailtoLink, '_blank')
  }
  if (text === t('common.copy')) {
    let copyText = null
    copyText = contactlist.value[position].link
    // Create a temporary textarea element
    const tempTextarea = document.createElement('textarea')
    tempTextarea.value = copyText
    document.body.appendChild(tempTextarea)

    // Select the text and copy it
    tempTextarea.select()
    document.execCommand('copy')

    // Remove the temporary textarea element
    document.body.removeChild(tempTextarea)
    // const copybtntxt = [copybtntxt0, copybtntxt1, copybtntxt2, copybtntxt3];
    contactlist.value[position].btns[btnPosition].text = t('common.copied')
    // copybtntxt[position].value = "已复制";
    setTimeout(() => {
      contactlist.value[position].btns[btnPosition].text = t('common.copy')
    }, 2000)
  }
  if (text === t('common.download')) {
    const downloadLink = contactlist.value[position].btns[btnPosition].action
    window.open(downloadLink, '_blank')
  }
}

onMounted(() => {
  initContactList()
})
</script>
<style lang="scss">
.customer-service {
  background: url('../../assets/images/login/cus-bg.png');
  width: 100%;
  height: 100vh;
  font-family: 'PingFang SC', sans-serif;
  &.kaka {
    background: url('../../assets/images/kaka/cus-bg-kaka.png') no-repeat center
      33%;
    background-color: #1e212c;

    .el-button--primary {
      --el-button-background-color: #ff4545;
      --el-button-border-color: #ff4545;
      &:hover,
      &:active {
        border-color: var(--el-button-border-color);
        background-color: var(--el-button-background-color);
        filter: brightness(1.2);
      }
    }
    .el-button--plain {
      --el-button-background-color: transparent;
      --el-button-border-color: #ff4545;
      --el-button-font-color: #ff4545;
      &:hover,
      &:active {
        --el-color-primary: #ff4545;
        border-color: var(--el-button-border-color);
        background-color: #fdf4f4;
      }
    }
    .bar {
      background: linear-gradient(
        90deg,
        #ff3333 0%,
        rgba(255, 26, 26, 0) 101.54%
      );
    }
    .inner {
      .title {
        color: #fff;
      }
      .services {
        z-index: 1;
        position: relative;

        .contact-box {
          background: linear-gradient(180deg, #feffff 0%, #fddada 100%);
          box-shadow: 0px -3px 4px 0px #ffffff inset, 0px 4px 4px 0px #0000000d;
        }
        .girl {
          position: relative;
          .kaka-cs-24 {
            display: flex;
            align-items: center;
            gap: 17px;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            border-radius: 22px;
            padding: 16px 20px;
            img {
              width: 86px;
            }
            p {
              font-size: 16px;
              font-style: italic;
              font-weight: 900;
              line-height: 19.36px;
            }
          }
        }
      }
    }
  }
  .inner {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 50px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .title {
    color: #333333;
    font-size: clamp(1.4rem, 5vh, 2.25rem);
    font-weight: bold;
  }
  .subtitle {
    color: #1b3d63;
    font-size: clamp(0.8rem, 2.2vh, 1.3rem);
    font-weight: 500;
    margin-top: clamp(6px, 1.5vh, 14px);
  }
  .bar {
    width: 100%;
    max-width: 600px;
    height: 5px;
    margin-top: 10px;
    background: linear-gradient(
      90deg,
      #33b5ff 0%,
      rgba(26, 173, 255, 0) 101.54%
    );
  }
  .services {
    display: flex;
    flex: 1;
    min-height: 0;
    justify-content: center;
    // margin: 50px auto;
    .contact-boxes {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 1fr;
      gap: clamp(8px, 2vh, 20px);
      width: 100%;
      height: 100%;
      max-width: 1000px;
      margin: 20px 30px;
    }
    .girl {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 0;
      box-sizing: border-box;
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
    .contact-box {
      box-shadow: 0px -3px 4px 0px #ffffff inset;
      box-shadow: 0px 4px 4px 0px #0000000d;
      background: linear-gradient(180deg, #feffff 0%, #daeefd 100%);
      border-radius: 24px;
      padding: clamp(6px, 1.6vh, 24px) 20px;
      text-align: center;
      width: 100%;
      min-width: 0;
      height: 100%;
      min-height: 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      .contacticon {
        width: clamp(22px, 5vh, 72px);
        height: clamp(22px, 5vh, 72px);
        margin-bottom: clamp(2px, 0.8vh, 12px);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .type {
        color: #1b3d63;
        font-weight: 600;
        font-size: clamp(0.85rem, 2.4vh, 1.3rem);
        margin: 0 0 clamp(2px, 0.8vh, 8px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        flex-shrink: 0;
      }
      .link {
        color: #1b3d63;
        font-weight: 600;
        font-size: clamp(0.7rem, 1.8vh, 1rem);
        margin: 0 0 clamp(2px, 1vh, 20px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        flex-shrink: 0;

        &.text-blue {
          color: #0d84ff;
          cursor: pointer;
        }
      }
      .buttons {
        display: flex;
        justify-content: center;
        gap: 12px;
        white-space: nowrap;
        flex-shrink: 0;
        .el-button {
          height: clamp(16px, 3.2vh, 36px);
          padding: 0 clamp(8px, 1.5vw, 15px);
          font-size: clamp(0.7rem, 1.6vh, 1rem);
          font-weight: 600;
          border-radius: 8px;
          margin-left: 0;
        }
        .el-button--plain {
          color: #3981ffb2;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .customer-service {
    .inner {
      padding: 20px;
    }
    height: unset;
    .title {
      font-size: 1.5rem;
    }
    .subtitle {
      font-size: 0.9rem;
    }
    .services {
      margin: 20px auto;
      .contact-boxes {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin: 10px;
      }
      .contact-box {
        padding: 16px 10px;
        min-height: 180px;
        .contacticon {
          width: 44px;
          height: 44px;
          margin-bottom: 8px;
        }
        .type {
          font-size: 1rem;
          margin-bottom: 4px;
        }
        .link {
          font-size: 0.8rem;
          margin-bottom: 12px;
        }
        .buttons {
          gap: 6px;
          .el-button {
            height: 24px;
            padding: 0 15px;
            font-size: 0.8rem;
          }
        }
      }
      .girl {
        min-height: 180px;
      }
    }
  }
}
</style>
